import React from 'react';
import axios from "../../../containers/api";
import {showCatchError} from "../../../helpers/Utils";
import {Button, Card, CardBody, ModalBody, Modal, ModalHeader, Row, ModalFooter} from "reactstrap";
import {Table} from "../../../components/table/Table";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import AddCustomerModal from "./components/AddCustomerModal";
import ManageCustomerAddress from "./components/ManageCustomerAddress";
import EditCustomer from "./components/EditCustomer";

class Customer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customers: [],
            provinces: [],
            addCustomerModal: false,
            editCustomerModal: false,
            manageCustomerModal: false,
            currentCustomer: []
        }
    }

    componentDidMount() {
        //this.checkPermission();
        this.GetCustomerByTransportationCompanyId();
        this.loadProvinces();
    }

    checkPermission = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/HasAccessTo?permissionName=Customer_List')
            .then((res) => {
                if (res.data) {
                    this.GetCustomerByTransportationCompanyId();
                    this.loadProvinces();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    GetCustomerByTransportationCompanyId = () => {
        axios.get('/api/v1/Customer/GetCustomerByTransportationCompanyId')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({customers: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
  
    loadProvinces = () => {
        axios.get('/api/v1/Province/GetAll')
            .then((res) => {
                this.setState({ provinces: res.data.data });
            })
            .catch((error) => {
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    //table functions
    deleteCustomer = (CustomerId) => {
        let request = {
            Id: CustomerId,
             
        };
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.post('/api/v1/Customer/DeleteCustomer', request)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.data.message, 'success')
                this.GetCustomerByTransportationCompanyId();
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            })
    };

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });

        if (modalName === "addCustomerModal" || modalName === "editCustomerModal") {
            this.GetCustomerByTransportationCompanyId();
        }
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>لیست مشتریان</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <div className="d-flex justify-content-center w-100">
                                    <Button outline color="primary" className="mx-3"
                                            onClick={() => {this.setState({addCustomerModal: true})}}>
                                        افزودن مشتری جدید
                                    </Button>
                                </div>
                                {
                                    this.state.customers !== null && this.state.customers.length>0 &&
                                    <Table
                                        tableHeaders={[
                                            "شماره حقیقی/حقوقی",
                                            "نام مشتری",
                                            "آدرس",
                                            "ویرایش",
                                            "حذف"
                                        ]}

                                        tableRow={this.state.customers}

                                        tableData={[
                                            customer => {
                                                return customer.meliCode;
                                            },
                                            customer => {
                                                return customer.customerFullName;
                                            },
                                            customer => {
                                                return (
                                                    <Button outline color="secondary" size="sm"
                                                        onClick={() => { this.setState({ currentCustomer: customer, manageCustomerModal: true }) }}>
                                                        مدیریت آدرس‌ها
                                                    </Button>
                                                );
                                            },
                                            customer => {
                                                return (
                                                    <Button outline color="info" size="sm"
                                                        onClick={() => this.setState({ currentCustomer: customer, editCustomerModal: true })}>
                                                        ویرایش
                                                    </Button>
                                                );
                                            },
                                            customer => {
                                                return (
                                                    <Button outline color="danger" size="sm"
                                                        onClick={() => this.props.showSweetAlert("آیا این مشتری حذف شود؟", "", "danger", () => this.deleteCustomer(customer.id))}>
                                                        حذف
                                                    </Button>
                                                );
                                            }
                                        ]}
                                    />
                                }
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.addCustomerModal} size="xlg" toggle={() => this.closeModal("addCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("addCustomerModal")}>
                        افزودن مشتری جدید
                    </ModalHeader>
                    <ModalBody>
                        <AddCustomerModal
                            provinces={this.state.provinces}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("addCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.editCustomerModal} size="xlg" toggle={() => this.closeModal("editCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("editCustomerModal")}>
                        ویرایش مشتری
                    </ModalHeader>
                    <ModalBody>
                        <EditCustomer
                            selectedCustomerToEdit={this.state.currentCustomer}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("editCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.manageCustomerModal} size="xlg" toggle={() => this.closeModal("manageCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("manageCustomerModal")}>
                        مدیریت آدرس‌های
                        {' '}
                        {this.state.currentCustomer.name}
                    </ModalHeader>
                    <ModalBody>
                        <ManageCustomerAddress
                            provinces={this.state.provinces}
                            currentCustomer={this.state.currentCustomer}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("manageCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

            </>
        );
    }
}

export default Customer;